import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Affix } from 'antd';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL } from '../Components/Constant';
import { useLocation } from 'react-router-dom';
import CloneOrgModal from './CloneOrgModal';
import ClonedOrgLogs from './ClonedOrgLogs';
import RefreshOrgModal from './RefreshOrg';

import {
  Layout,
  Card,
  Typography,
  Row,
  Col,
  Statistic,
  Tag,
  Button,
  Descriptions,
  Progress,
  Avatar,
  Space,
  Spin,
  Alert,
  Empty,
  Badge,
  Form,
  Input,
  Select,
  message,
} from 'antd';
import {
  ArrowLeftOutlined,
  UserOutlined,
  CopyOutlined,
  DatabaseOutlined,
  ApiOutlined,
  SettingOutlined,
  FileTextOutlined,
  EditOutlined,
  SaveOutlined,
  CloseCircleOutlined,
  ConsoleSqlOutlined,
} from '@ant-design/icons';
import { fetchOrgData } from '../Redux Components/dataSlice';
import ClonedOrgsSection from './ClonedOrganisations';

const { Header, Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;
const OrganizationDetails = () => {
  // Save all edited fields
  const handleSaveAll = async () => {
    try {
    
      const values = await form.validateFields();
      const body={
        "org_info":values
      }
      const apiService = new ApiService(
        `${BASE_URL}/super_admin/organizations/${organization.id}`, 
        { 'Content-Type': 'application/json' },
        'PUT',
        body
      );
      await apiService.makeCall();
      fetchData();
      handleCancelAll();
      message.success('Organization details updated successfully!');
    } catch (err) {
      message.error('Failed to save changes.');
    }
  };
  // Handler to enable editing for all fields
  const handleEditAll = () => {
    setEditingName(true);
    setEditingDomain(true);
    setEditingStatus(true);
    setEditingPlan(true);
    setEditingContactEmail(true);
    setEditingCategory(true);
    setEditingFirstName(true);
    setEditingLastName(true);
    setEditingUsername(true);
    setEditingInstanceUrl(true);
  };

  // Handler to cancel editing for all fields
  const handleCancelAll = () => {
    setEditingName(false);
    setEditingDomain(false);
    setEditingStatus(false);
    setEditingPlan(false);
    setEditingContactEmail(false);
    setEditingCategory(false);
    setEditingFirstName(false);
    setEditingLastName(false);
    setEditingUsername(false);
    setEditingInstanceUrl(false);
    form.resetFields();
    form.setFieldsValue(organization);
  };
  const { id } = useParams();
  const navigate = useNavigate();

  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();

  // New state variables for individual inline editing
  const [editingName, setEditingName] = useState(false);
  const [editingDomain, setEditingDomain] = useState(false);
  const [editingStatus, setEditingStatus] = useState(false);
  const [editingPlan, setEditingPlan] = useState(false);
  const [editingContactEmail, setEditingContactEmail] = useState(false);
  const [editingCategory, setEditingCategory] = useState(false);
  const [editingFirstName, setEditingFirstName] = useState(false);
  const [editingLastName, setEditingLastName] = useState(false);
  const [editingUsername, setEditingUsername] = useState(false);
  const [editingInstanceUrl, setEditingInstanceUrl] = useState(false);
  const [users, setUsers] = useState([]);
  const location = useLocation(); 
  const [clonedOrgs,setClonedOrgs] = useState([]);
  const [isCloneModalVisible, setIsCloneModalVisible] = useState(false);
  const [isProductionOrg,setIsProductionOrg] = useState(true);
  const [isRefreshModalVisible, setIsRefreshModalVisible] = useState(false);
  //const { apiOrg } = location.state || '';  

  // Hover states for showing edit icon
  const [hoveredField, setHoveredField] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    setOrganization(null);

    try {
     

        if (id) {
          console.log('Found organization in API data:', id);
          const apiOrg = id;
            const apiServiceForObjectDetails = new ApiService(
                    `${BASE_URL}/super_admin/organizations/${apiOrg}`,
                    { 'Content-Type': 'application/json' },
                    'GET'
                  );
            const detailedData = await apiServiceForObjectDetails.makeCall();
            // setIsProductionOrg(detailedData?.source_org_id ? true : false);
            setIsProductionOrg(detailedData?.org_info?.source_org_id ? false : true);
            setUsers(detailedData.users || []);

          if (detailedData) {
            const mappedOrg = {
              id: detailedData.org_info._id || apiOrg,
              source_org_id: detailedData?.org_info?.source_org_id || null,
              name: detailedData.org_info.name || apiOrg,
              domain: detailedData.org_info.instance_url ? new URL(detailedData.org_info.instance_url).hostname : 'N/A',
              instance_url: detailedData.org_info.instance_url || 'N/A',
              status: detailedData.org_info.status ,
              created: detailedData.org_info.created_at ,
              createdAt: detailedData.org_info.created_at ,
              lastActivity: detailedData.org_info.updated_at ,
              contact_email: detailedData.org_info.contact_email,
              category: detailedData.org_info.category,
              first_name: detailedData.org_info.first_name,
              last_name: detailedData.org_info.last_name,
              username: detailedData.org_info.username,
              org_type: detailedData.org_info.org_type || 'N/A',
              plan: detailedData.org_info.subscription_plan || 'Professional',
              users: {
                total: detailedData.total_users || 0,
                active: detailedData.active_users  || 0,
                inactive: detailedData.inactive_users || 0,
                admins: detailedData.admin_users || 0,
              },
              objects: {
                total: detailedData.total_objects  || 0,
                custom: detailedData.custom_objects  || 0,
                standard: detailedData.standard_objects || 0,
              },
              storage: {
                percentage: detailedData.storage_usage_percentage || 0,
                used: detailedData.storage_used_gb || 0,
                limit: detailedData.storage_limit_gb || 0,
              },
              apiCalls: {
                daily: detailedData.daily_api_calls || 0,
                monthly: detailedData.monthly_api_calls || 0,
                limit: detailedData.api_call_limit || 0,
              },
              features: {
                customObjects: detailedData.custom_objects > 0,
                apiAccess: detailedData.api_access || false,
                advancedReporting: detailedData.advanced_reporting || false,
                sso: detailedData.sso_enabled || false,
              },
            };
            setOrganization(mappedOrg);
            form.setFieldsValue(mappedOrg);
          } else {
            setOrganization([]); 
          }
        } else {
          setOrganization(null);
          console.log('Organization not found in API data.');
        }
      
    } catch (err) {
      console.error('Error fetching from API:', err);
      const errorMessage = err && typeof err === 'object'
        ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to fetch record due to an unknown error';

      if(errorMessage==='Invalid or missing super admin token'){
        navigate('/Admin/Authentication');
      }
      setError(errorMessage);
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // fetchClonedOrgs();
  }, [id]);

  useEffect(() => {
    if (organization?.id) {
      console.log('Organization ID changed, fetching cloned orgs:', organization.id);
      fetchClonedOrgs();
    }
  }, [organization?.id]);
  
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'success';
      case 'inactive': return 'default';
      default: return 'default';
    }
  };

  const getPlanColor = (plan) => {
    switch (plan) {
      case 'Enterprise': return 'purple';
      case 'Professional': return 'blue';
      case 'Basic': return 'green';
      default: return 'default';
    }
  };

  // Generic handler to start editing a field
  const handleEdit = (fieldSetter) => {
    fieldSetter(true);
  };

  // Generic handler to save a field
  const handleSave = async (fieldSetter, fieldName) => {
    try {
      const values = await form.validateFields([fieldName]);
      const newOrgData = { ...organization, ...values };
      setOrganization(newOrgData);
      fieldSetter(false);
      message.success(`${fieldName} updated successfully!`);
    } catch (err) {
      console.error('Validation failed:', err);
      message.error(`Failed to update ${fieldName}. Please correct the error.`);
    }
  };

  // Generic handler to cancel editing
  const handleCancel = (fieldSetter) => {
    fieldSetter(false);
    form.resetFields();
    form.setFieldsValue(organization);
  };


  const handleToggleStatus = async () => {
    try {

      const status = organization.status === 'active' ? 'deactivate' : 'activate';
      const newStatus = organization.status === 'active' ? 'inactive' : 'active';
      const apiService = new ApiService(
        `${BASE_URL}/super_admin/orgs/${organization.id}/${status}`,
        { 'Content-Type': 'application/json' },
        'POST'
      );
      await apiService.makeCall();
      message.success(`Organization ${newStatus === 'active' ? 'activated' : 'deactivated'} successfully!`);
      fetchData();
    }
    catch (err) {
      console.error('Error toggling status:', err);
    }
  };

  const handleOrgApproval = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/super_admin/organizations/${organization.id}/approve_org`,
        { 'Content-Type': 'application/json' },
        'POST'
      );
      await apiService.makeCall();
      message.success('Organization approved successfully!');
      fetchData();
    } catch (err) {
      console.error('Error approving organization:', err);
      message.error('Failed to approve organization.');
    }
  };

  const fetchClonedOrgs = async () => {
    try {
      setLoading(true);
      console.log('Fetching cloned orgs for organization ID:', organization);
      const apiService = new ApiService(
        `${BASE_URL}/super_admin/get_sandboxs/${organization?.id}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      console.log('Fetched cloned orgs:', response);
      setClonedOrgs(response?.sandboxs || []);
      // setClonedOrgs([]);
    } catch (err) {
      console.error('Error fetching cloned orgs:', err);
      message.error('Failed to fetch cloned organizations.');
    } finally {
      setLoading(false);
    }
    console.log('Fetch Cloned Orgs clicked');
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
          <p style={{ marginTop: '20px', fontSize: '18px' }}>Loading organization details...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Alert
            message="Error"
            description={error}
            type="error"
            showIcon
          />
          <Button style={{ marginTop: '20px' }} onClick={fetchData}>
            Try Again
          </Button>
        </div>
      );
    }

    if (!organization) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Empty
            description={
              <Text style={{ fontSize: '18px' }}>No organization found with ID "{id}"</Text>
            }
          />
          <Button type="primary" style={{ marginTop: '20px' }} onClick={() => navigate('/Admin')}>
            Back to Dashboard
          </Button>
        </div>
      );
    }

    return (
      <Form form={form} layout="vertical" initialValues={organization}>
        <Card style={{ marginBottom: 24 }}>
          <Row gutter={24} align="middle">
            <Col>
              <Avatar size={80} style={{ backgroundColor: '#1890ff' }}>
                {organization.name.charAt(0).toUpperCase()}
              </Avatar>
            </Col>
            <Col flex="auto">
              <Title level={2} style={{ margin: 0 }}>{organization.name}</Title>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                Org ID: {organization.id}
              </Text>
              <div style={{ marginTop: 8 }}>
                <Tag color={getPlanColor(organization.plan)} size="large">{organization.plan}</Tag>
                <Badge
                  status={getStatusColor(organization.status)}
                  text={organization.status}
                  style={{ marginLeft: 16, fontSize: '16px' }}
                />
              </div>
            </Col>
             <Col>
             {organization.status === 'pending' && (
               <Button type="primary" onClick={handleOrgApproval} style={{ marginRight: 8 }}>Approve</Button>
             )}

            {organization.org_type === 'sandbox' && organization.status === 'active' && (
              <Button
                icon={<CopyOutlined />}
                onClick={() => setIsRefreshModalVisible(true)}
                style={{ marginRight: 8 }}
              >
                Update Sandbox
              </Button>
            )}
            <Button type="primary" icon={<EditOutlined />} onClick={handleEditAll} style={{ marginRight: 8 }}>
            Edit
          </Button>
<Button
    danger={organization.status === 'active'}
    type={organization.status === 'active' ? 'default' : 'primary'}
    onClick={handleToggleStatus}
  >
    {organization.status === 'active' ? 'Deactivate' : 'Activate'}
  </Button>
          
            </Col> 
          </Row>
        </Card>

        <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            {/* Basic Information - INLINE EDITING */}
            <Card title="Organization Information" style={{ marginBottom: 24 }}>
              <Descriptions bordered column={2}>
                <Descriptions.Item label="Organization Name">
                  {editingName ? (
                    <Form.Item name="name" style={{ margin: 0 }} rules={[{ required: true, message: 'Name is required' }]}> 
                      <Input autoFocus />
                    </Form.Item>
                  ) : (
                    <div
                      style={{ display: 'inline-block', width: '100%' }}
                      onMouseEnter={() => setHoveredField('name')}
                      onMouseLeave={() => setHoveredField(null)}
                    >
                      <Space>
                        <Text>{organization.name}</Text>
                        {hoveredField === 'name' && (
                          <EditOutlined onClick={() => handleEdit(setEditingName)} style={{ cursor: 'pointer' }} />
                        )}
                      </Space>
                    </div>
                  )}
                </Descriptions.Item>
                
                <Descriptions.Item label="Plan">
                  {editingPlan ? (
                    <Form.Item name="plan" style={{ margin: 0 }}>
                      <Select style={{ width: 120 }}>
                        <Option value="Basic">Basic</Option>
                        <Option value="Professional">Professional</Option>
                        <Option value="Enterprise">Enterprise</Option>
                      </Select>
                    </Form.Item>
                  ) : (
                    <div
                      style={{ display: 'inline-block', width: '100%' }}
                      onMouseEnter={() => setHoveredField('plan')}
                      onMouseLeave={() => setHoveredField(null)}
                    >
                      <Space>
                        <Tag color={getPlanColor(organization.plan)}>{organization.plan}</Tag>
                        {hoveredField === 'plan' && (
                          <EditOutlined onClick={() => handleEdit(setEditingPlan)} style={{ cursor: 'pointer' }} />
                        )}
                      </Space>
                    </div>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Created">
                  <Text>{new Date(organization.createdAt).toLocaleDateString()}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Last Activity">
                  <Text>{new Date(organization.lastActivity).toLocaleDateString()}</Text>
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {organization.contact_email && (
              <Card title="Detailed Information" style={{ marginBottom: 24 }}>
                <Descriptions bordered column={2}>
                  <Descriptions.Item label="Contact Email">
                    {editingContactEmail ? (
                      <Form.Item name="contact_email" style={{ margin: 0 }} rules={[{ type: 'email', message: 'Invalid email' }]}> 
                        <Input />
                      </Form.Item>
                    ) : (
                      <div
                        style={{ display: 'inline-block', width: '100%' }}
                        onMouseEnter={() => setHoveredField('contact_email')}
                        onMouseLeave={() => setHoveredField(null)}
                      >
                        <Space>
                          <Text>{organization.contact_email}</Text>
                          {hoveredField === 'contact_email' && (
                            <EditOutlined onClick={() => handleEdit(setEditingContactEmail)} style={{ cursor: 'pointer' }} />
                          )}
                        </Space>
                      </div>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Category">
                    {editingCategory ? (
                      <Form.Item name="category" style={{ margin: 0 }}>
                        <Input />
                      </Form.Item>
                    ) : (
                      <div
                        style={{ display: 'inline-block', width: '100%' }}
                        onMouseEnter={() => setHoveredField('category')}
                        onMouseLeave={() => setHoveredField(null)}
                      >
                        <Space>
                          <Tag color="blue">{organization.category || 'N/A'}</Tag>
                          {hoveredField === 'category' && (
                            <EditOutlined onClick={() => handleEdit(setEditingCategory)} style={{ cursor: 'pointer' }} />
                          )}
                        </Space>
                      </div>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Primary Contact">
                    {(editingFirstName || editingLastName) ? (
                      <Space>
                        <Form.Item name="first_name" style={{ margin: 0 }}>
                          <Input placeholder="First Name" />
                        </Form.Item>
                        <Form.Item name="last_name" style={{ margin: 0 }}>
                          <Input placeholder="Last Name" />
                        </Form.Item>
                      </Space>
                    ) : (
                      <div
                        style={{ display: 'inline-block', width: '100%' }}
                        onMouseEnter={() => setHoveredField('primaryContact')}
                        onMouseLeave={() => setHoveredField(null)}
                      >
                        <Space>
                          <Text>
                            {organization.first_name && organization.last_name ? `${organization.first_name} ${organization.last_name}` : 'N/A'}
                          </Text>
                          {hoveredField === 'primaryContact' && (
                            <EditOutlined onClick={() => {
                              handleEdit(setEditingFirstName);
                              handleEdit(setEditingLastName);
                            }} style={{ cursor: 'pointer' }} />
                          )}
                        </Space>
                      </div>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Username">
                    {editingUsername ? (
                      <Form.Item name="username" style={{ margin: 0 }}>
                        <Input />
                      </Form.Item>
                    ) : (
                      <div
                        style={{ display: 'inline-block', width: '100%' }}
                        onMouseEnter={() => setHoveredField('username')}
                        onMouseLeave={() => setHoveredField(null)}
                      >
                        <Space>
                          <Text>{organization.username || 'N/A'}</Text>
                          {hoveredField === 'username' && (
                            <EditOutlined onClick={() => handleEdit(setEditingUsername)} style={{ cursor: 'pointer' }} />
                          )}
                        </Space>
                      </div>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Instance URL">
                    {editingInstanceUrl ? (
                      <Form.Item name="instance_url" style={{ margin: 0 }} rules={[{ type: 'url', message: 'Invalid URL' }]}> 
                        <Input />
                      </Form.Item>
                    ) : (
                      <div
                        style={{ display: 'inline-block', width: '100%' }}
                        onMouseEnter={() => setHoveredField('instance_url')}
                        onMouseLeave={() => setHoveredField(null)}
                      >
                        <Space>
                          <a href={organization.instance_url} target="_blank" rel="noopener noreferrer">
                            {organization.instance_url || 'N/A'}
                          </a>
                          {hoveredField === 'instance_url' && (
                            <EditOutlined onClick={() => handleEdit(setEditingInstanceUrl)} style={{ cursor: 'pointer' }} />
                          )}
                        </Space>
                      </div>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Last Updated">
                    <Text>
                      {organization.lastActivity ? new Date(organization.lastActivity).toLocaleDateString() : 'N/A'}
                    </Text>
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            )}

            {/* Save/Cancel buttons for editing mode - always at bottom of left column */}
            {(editingName || editingDomain || editingStatus || editingPlan || editingContactEmail || editingCategory || editingFirstName || editingLastName || editingUsername || editingInstanceUrl) && (
             

               <Affix offsetBottom={0}>
                        <div style={{
                            width: '100%',
                            padding: '8px 0',
                            background: 'rgba(240, 242, 245, 0.9)',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            zIndex: 1000,
                        }}>
                            <Row justify="center">
                                <Button onClick={handleCancelAll} style={{ marginRight: 6 }} size="small">
                                    Cancel
                                </Button>
                                <Button type="primary" onClick={handleSaveAll} form="recordDetailsForm" size="small">
                                    Save
                                </Button>
                            </Row>
                        </div>
                    </Affix>


            )}

            {/* User Statistics - MUST NOT BE REMOVED AND NOT EDITABLE */}
            <Card title="User Statistics" style={{ marginBottom: 24 }}>
              <Row gutter={16}>
                <Col span={6}>
                  <Statistic
                    title="Total Users"
                    value={organization.users.total}
                    prefix={<UserOutlined />}
                    valueStyle={{ fontSize: '24px' }}
                  />
                </Col>
                <Col span={6}>
                  <Statistic
                    title="Active Users"
                    value={organization.users.active}
                    valueStyle={{ color: '#52c41a', fontSize: '24px' }}
                  />
                </Col>
                <Col span={6}>
                  <Statistic
                    title="Inactive Users"
                    value={organization.users.inactive}
                    valueStyle={{ color: '#faad14', fontSize: '24px' }}
                  />
                </Col>
                <Col span={6}>
                  <Statistic
                    title="Admins"
                    value={organization.users.admins}
                    valueStyle={{ color: '#722ed1', fontSize: '24px' }}
                  />
                </Col>
              </Row>
            </Card>

            {/* Object Statistics - MUST NOT BE REMOVED AND NOT EDITABLE */}
            <Card title="Object Statistics" style={{ marginBottom: 24 }}>
              <Row gutter={16}>
                <Col span={8}>
                  <Statistic
                    title="Total Objects"
                    value={organization.objects.total}
                    prefix={<DatabaseOutlined />}
                    valueStyle={{ fontSize: '24px' }}
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title="Custom Objects"
                    value={organization.objects.custom}
                    valueStyle={{ color: '#1890ff', fontSize: '24px' }}
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title="Standard Objects"
                    value={organization.objects.standard}
                    valueStyle={{ color: '#52c41a', fontSize: '24px' }}
                  />
                </Col>
              </Row>
            </Card>

            {/* Storage & API Usage - MUST NOT BE REMOVED AND NOT EDITABLE */}
            <Card title="Storage & API Usage" style={{ marginBottom: 24 }}>
              <Row gutter={24}>
                <Col span={12}>
                  <Card size="small" title="Storage Usage" style={{ marginBottom: 16 }}>
                    <Progress
                      percent={organization.storage.percentage}
                      status={organization.storage.percentage > 90 ? 'exception' : 'active'}
                      size="large"
                    />
                    <Text style={{ fontSize: '14px' }}>
                      {organization.storage.used} GB / {organization.storage.limit} GB used
                    </Text>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card size="small" title="API Calls" style={{ marginBottom: 16 }}>
                    <Statistic
                      title="Daily"
                      value={organization.apiCalls.daily}
                      suffix="/ day"
                      valueStyle={{ fontSize: '18px' }}
                    />
                    <Statistic
                      title="Monthly"
                      value={organization.apiCalls.monthly}
                      suffix="/ month"
                      valueStyle={{ fontSize: '18px' }}
                    />
                    <Text style={{ fontSize: '14px' }}>
                      Limit: {organization.apiCalls.limit.toLocaleString()} / month
                    </Text>
                  </Card>
                </Col>
              </Row>
            </Card>

            {/* Features & Capabilities - MUST NOT BE REMOVED AND NOT EDITABLE */}
            <Card title="Features & Capabilities">
              <Row gutter={16}>
                <Col span={6}>
                  <Tag color={organization.features.customObjects ? 'green' : 'red'} size="large">
                    Custom Objects: {organization.features.customObjects ? 'Yes' : 'No'}
                  </Tag>
                </Col>
                <Col span={6}>
                  <Tag color={organization.features.apiAccess ? 'green' : 'red'} size="large">
                    API Access: {organization.features.apiAccess ? 'Yes' : 'No'}
                  </Tag>
                </Col>
                <Col span={6}>
                  <Tag color={organization.features.advancedReporting ? 'green' : 'red'} size="large">
                    Advanced Reporting: {organization.features.advancedReporting ? 'Yes' : 'No'}
                  </Tag>
                </Col>
                <Col span={6}>
                  <Tag color={organization.features.sso ? 'green' : 'red'} size="large">
                    SSO: {organization.features.sso ? 'Yes' : 'No'}
                  </Tag>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            {/* Quick Actions */}
            <Card title="Quick Actions" style={{ marginBottom: 24 }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button 
                 icon={<UserOutlined />}
                  block size="large"
                  onClick={() => navigate(`/Admin/users/${id}`)}>
                  Manage Users
                </Button>
                <Button
                  icon={<DatabaseOutlined />}
                  block
                  size="large"
                  onClick={() => navigate(`/Admin/objects/${id}`)}
                >
                  Manage Objects
                </Button>
                <Button icon={<SettingOutlined />} block size="large">
                  Organization Settings
                </Button>
                <Button icon={<ApiOutlined />} block size="large">
                  API Configuration
                </Button>
                <Button icon={<FileTextOutlined />} block size="large">
                  View Reports
                </Button>
              </Space>
            </Card>

            {/* Summary Stats */}
            <Card title="Summary Statistics">
              <Space direction="vertical" style={{ width: '100%' }} size="large">
                <div>
                  <Text type="secondary">Storage Usage</Text>
                  <div style={{ marginTop: 8 }}>
                    <Progress
                      percent={organization.storage.percentage}
                      size="small"
                      format={() => `${organization.storage.used}/${organization.storage.limit}GB`}
                    />
                  </div>
                </div>

                <div>
                  <Text type="secondary">API Usage</Text>
                  <div style={{ marginTop: 8 }}>
                    <Progress
                      percent={(organization.apiCalls.monthly / organization.apiCalls.limit) * 100}
                      size="small"
                      format={() => `${organization.apiCalls.monthly.toLocaleString()}/${organization.apiCalls.limit.toLocaleString()}`}
                    />
                  </div>
                </div>

                <div>
                  <Text type="secondary">User Activity</Text>
                  <div style={{ marginTop: 8 }}>
                    <Text strong>{organization.users.active}</Text>
                    <Text type="secondary"> / {organization.users.total} active users</Text>
                  </div>
                </div>
              </Space>
            </Card>

            {/* Cloned Orgs */}
            {isProductionOrg && (

            <Card
              title="Associated Sandboxes"
              style={{ marginTop: 24 }}
              extra={
                <Button type="primary" onClick={() => setIsCloneModalVisible(true)}>
                  New
                </Button>
              }
            >
              <ClonedOrgsSection clonedOrgs={clonedOrgs} />
            </Card>
          )}
          {!isProductionOrg && organization?.id ? (
            <Card title="Organization Logs" style={{ marginTop: 24 }}>
              <ClonedOrgLogs clonedOrg={organization?.id} />
            </Card>
          ) : null}

          </Col>
          <CloneOrgModal
            visible={isCloneModalVisible}
            onClose={() => setIsCloneModalVisible(false)}
            organizationId={organization.id}
            onCloneSuccess={fetchClonedOrgs} // refresh cloned orgs after successful clone
          />
          <RefreshOrgModal
            visible={isRefreshModalVisible}
            onClose={() => setIsRefreshModalVisible(false)}
            sourceOrgId={organization.source_org_id}
            targetOrgId={organization.id}
            onRefreshSuccess={fetchData}
          />

        </Row>
      </Form>
    );  
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Replace your old Header with this one */}
      <Header style={{ background: '#fff', padding: '0 24px', borderBottom: '1px solid #f0f0f0' }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Space>
              {/* Back to Dashboard */}
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate('/Admin')}
                style={{ marginRight: 16 }}
              >
                Back to Dashboard
              </Button>

              {/* Show "Previous Page" only if NOT a production org */}
              {!isProductionOrg && organization?.source_org_id && (
                <Button
                  icon={<ArrowLeftOutlined />}
                  type="default"
                  onClick={() => navigate(`/Admin/organization/${organization.source_org_id}`)}
                  style={{ marginRight: 16 }}
                >
                  Previous Page
                </Button>
              )}

              <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                <SettingOutlined style={{ marginRight: 8 }} />
                Organization Details
              </Title>
            </Space>
          </Col>
        </Row>
      </Header>

      <Content style={{ margin: '24px', background: '#f5f5f5' }}>
        {renderContent()}
      </Content>
    </Layout>
  );
};

export default OrganizationDetails;